/*
 * Copyright (c) 2022 automata-network/tgb-donation authors and contributors.
 * This software may be modified and distributed under the terms of MIT license.
 * Refer to the LICENSE file for details.
 */
// import { StrictMode } from 'react'
import { useEffect } from 'react'

import { HashRouter } from 'react-router-dom'

import { initTracker, track } from 'src/tracker'

import Providers from './Providers'
import Routes from './Routes'
import { GlobalThemeStyle } from './Theme'

initTracker()

const App = () => {
  useEffect(() => {
    track('viewPage', {})
  }, [])

  return (
    <>
      {/*<StrictMode></StrictMode>*/}
      <HashRouter>
        <Providers>
          <GlobalThemeStyle />
          <Routes />
        </Providers>
      </HashRouter>
    </>
  )
}

export default App
